import { getLegalDocument } from '@filmspo/legal-content';

import { LegalDocumentContent } from '../components/LegalDocument';

export function PrivacyPage() {
  return (
    <main className="legal-page">
      <div className="legal-container">
        <LegalDocumentContent document={getLegalDocument('privacy')} />
      </div>
    </main>
  );
}
